<template>
  <el-drawer
    :title="$t('home.advancedSearch')"
    :visible.sync="searchDrawer"
    direction="ltr"
    size="600px"
    @closed="handleClosed"
  >
    <el-form label-position="top" size="small">
      <el-row
        :gutter="10" type="flex" justify="left"
        style="flex-wrap: wrap;padding: 0 20px;box-sizing: border-box"
      >
        <el-col :span="12">
          <!--  运单号   -->
          <el-form-item>
            <div class="selectLabel">
              <el-select v-model="localParams.selectType" style="width: 130px">
                <el-option key="1" :label="$t('newOrder.waybillNumber')" :value="1" />
                <el-option key="3" :label="$t('GlobalSetObj.ScanNumber')" :value="3" />
              </el-select>
            </div>
            <el-input
              v-model="localParams.inputValue"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--货物类型-->
          <el-form-item :label="$t('placeOrder.cargoType')">
            <el-select
              v-model="localParams.cargoType"
              :placeholder="$t('basicData.PleaseSelect')"
              clearable
              filterable
              style="width: 100%;"
            >
              <el-option
                v-for="item in cargoTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--客户-->
          <el-form-item :label="$t('collectionCenter.client')">
            <el-select
              v-model="localParams.customerIdList"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              style="width: 100%"
              @change="getMerchantList"
              @clear="getCustomerPage('')"
              @focus="getCustomerPage('', true)"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--商户-->
          <el-form-item :label="$t('collectionCenter.CommercialOwner')">
            <el-select
              v-model="localParams.merchantCodeList"
              :disabled="
                !localParams.customerIdList || localParams.customerIdList.length === 0
              "
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in merchantList"
                :key="index"
                :label="item.merchantName + '（' + item.merchantCode + '）'"
                :value="item.merchantCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- 订单创建时间 -->
          <el-form-item :label="$t('collectionCenter.orderCreateT')">
            <el-date-picker
              v-model="localParams.timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('collectionCenter.EndTime')"
              :range-separator="$t('collectionCenter.to')"
              :start-placeholder="$t('collectionCenter.StartTime')"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="selectType1">
            <div class="selectLabel">
              <el-select v-model="localParams.selectType1" style="width: 170px">
                <el-option
                  key="1"
                  :label="$t('customerManagements.trackingStalledLocation')"
                  :value="1"
                /><!-- 轨迹停更网点 -->
                <el-option
                  key="2"
                  :label="$t('customerManagements.operatorNameSite')"
                  :value="2"
                /><!-- 次新操作人网点 -->
              </el-select>
            </div>
            <el-select
              v-model="localParams.latestTraceSiteList1"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--  最新轨迹上级转运中心   -->
          <el-form-item prop="selectType2">
            <div class="selectLabel">
              <el-select v-model="localParams.selectType2" style="width: 170px">
                <el-option
                  key="1"
                  :label="$t('customerManagements.newupTransferName')"
                  :value="1"
                />
                <el-option
                  key="2"
                  :label="$t('customerManagements.nextNewTransferName')"
                  :value="2"
                />
              </el-select>
            </div>
            <el-select
              v-model="localParams.upTransferList1"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in transferList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="handleReset">{{ $t('newOrder.reset') }}</el-button>
      <el-button size="small" type="primary" @click="handleSearch">{{ $t('newOrder.search') }}</el-button>
    </div>
  </el-drawer>
</template>

<script>
import cloneDeep from 'lodash-es/cloneDeep';
import { getMerchantByCustomerIdList } from '@/api/orderApi';
import { apiCustomerPage } from '@/api/customer';

const DEFAULT_PARAMS = {
  selectType: 1,
  inputValue: '',
  customerIdList: [],
  merchantCodeList: [],
  timeValue: [],
  selectType1: 1,
  latestTraceSiteList1: [],
  selectType2: 1,
  upTransferList1: [],
  cargoType: 0
};

export default {
  name: 'SearchCom',
  props: {
    siteList: {
      type: Array,
      default: () => []
    },
    transferList: {
      type: Array,
      default: () => []
    },
    cargoTypeList: {
      type: Array,
      default: () => []
    },
    defaultTimeValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchDrawer: false,
      localParams: cloneDeep(DEFAULT_PARAMS),
      customerList: [],
      merchantList: []
    };
  },
  watch: {
    defaultTimeValue: {
      handler(val) {
        if (!this.searchDrawer && val && val.length > 0) {
          this.localParams.timeValue = [...val];
        }
      },
      immediate: true
    }
  },
  methods: {
    showDialog() {
      if (!this.localParams.customerIdList || this.localParams.customerIdList.length === 0) {
        this.merchantList = [];
      }
      this.searchDrawer = true;
    },
    handleSearch() {
      const params = cloneDeep(this.localParams);
      const timeValue = params.timeValue;
      delete params.timeValue;
      this.$emit('search', { params, timeValue });
      this.searchDrawer = false;
    },
    handleReset() {
      // 重置时，时间改为父组件传入的默认时间
      const keepTime =
        this.defaultTimeValue && this.defaultTimeValue.length > 0
          ? [...this.defaultTimeValue]
          : [];
      this.localParams = cloneDeep(DEFAULT_PARAMS);
      this.localParams.timeValue = keepTime;
      this.customerList = [];
      this.merchantList = [];
    },
    // 提供给父组件：获取当前选中的查询条件（未点搜索直接关闭也能生效）
    getLocalParams() {
      return cloneDeep(this.localParams);
    },
    handleClosed() {
      // 抽屉关闭时不做额外操作
    },
    // 商户联动
    getMerchantList(val) {
      if (!val || val.length === 0) {
        this.localParams.merchantCodeList = [];
        this.merchantList = [];
        return;
      }
      getMerchantByCustomerIdList({ customerIdList: val }).then((res) => {
        if (res.code === 200) {
          this.merchantList = res.data;
        }
      });
    },
    // 客户远程搜索
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerList.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerList = res.data.records;
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerList = res.data.records;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.selectLabel {
  display: flex;
  align-items: center;

  ::v-deep .el-input {
    height: 28px !important;
  }

  ::v-deep .el-input__inner {
    border: none;
    box-shadow: none;
    color: #606266;
    font-size: 14px;
    background: transparent;
    padding: 0;
    text-align: left;
  }

  ::v-deep .el-input__icon {
    line-height: 28px;
  }
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
}
</style>
